import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from './loader.component';
import { LdsRingComponent } from './lds-ring/lds-ring.component';

@NgModule({
  declarations: [LoaderComponent, LdsRingComponent],
  imports: [CommonModule],
  exports: [LoaderComponent, LdsRingComponent],
})
export class LoaderModule {}
